import ProfissionalRepositorio from "@/repositorios/profissional/profissional.repositorio"
import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"

const profissionalRepositorio = new ProfissionalRepositorio()
const usuarioRepositorio = new UsuariosRepositorio()

export const obterBase64 = (arquivo: string): string => {
  const image64 = Buffer.from(arquivo, "binary").toString("base64")
  return `data:image/png;base64,${image64}`
}

export const usarFoto = () => {
  const obterUrlFotoProfissional = async (
    urlFotoDeAvatar: string
  ): Promise<string | null> => {
    try {
      const response = await profissionalRepositorio.obterFotoProfissional(
        urlFotoDeAvatar
      )

      return obterBase64(response)
    } catch (error) {
      if (
        process.env.NODE_ENV === "test" ||
        process.env.NODE_ENV === "local" ||
        process.env.NODE_ENV === "development"
      ) {
        console.error({ error })
      }
      return null
    }
  }

  const obterUrlFotoUsuario = async (
    urlFotoDeAvatar: string
  ): Promise<string | null> => {
    try {
      const response = await usuarioRepositorio.obterFotoUsuario(
        urlFotoDeAvatar
      )

      return obterBase64(response)
    } catch (error) {
      if (
        process.env.NODE_ENV === "test" ||
        process.env.NODE_ENV === "local" ||
        process.env.NODE_ENV === "development"
      ) {
        console.error({ error })
      }
      return null
    }
  }
  return { obterUrlFotoProfissional, obterUrlFotoUsuario }
}
